import React from "react";
import Highlighter from "react-highlight-words";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setBreadCrumb } from "../../../../store/userSlice";
import { useState } from "react";
import { GoEye } from "react-icons/go";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import financeDeskEmployeeDetails from "./findDeskEmployeeDetails";
import OPS2_EmployeeDetails from "../WorkFlowDependentAddition/OPS2_EmployeeDetails";

export default function dependentPaymentSummary({
  token,
  list = [],
  titles = [],
  action,
  setAction,
}) {
  const [newIndex, setnewIndex] = useState(1);
  const [searchWords, setSearchWords] = React.useState([]);
  const [item, setItem] = useState("");

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const dispatch = useDispatch();

  const [downloadLoading, setDownloadLoading] = useState(false);

  const [dependentDetails, SetDependentDetails] = useState();

  const getData = async () => {
    const params = "INSURANCE VENDOR PAYMENT";
    try {
      const response = await nodeinstance.get(
        `insurance-dependent/insuranceVendorPayment`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        SetDependentDetails(response?.data);
      }
    } catch (error) {
      console.log("error.......", error);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  console.log(".......dependentDetails......", dependentDetails);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(dependentDetails?.data);

  const uploadFile = async (file) => {
    console.log(file);
    if (file) {
      setLoading((p) => ({ ...p, loadingId: file }));
      try {
        const response = await nodeinstance.get(
          `/insurance-dependent/dependentDetails/111`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          // apiCall()
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
        console.log(response.data);
        setItem(response.data.data);
        setAction(true);
      } catch (err) {
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/downloadDependentSummary`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `DependentSummary`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const downloadEmployeeFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `insurance-dependent/downloadDependentbyempId/111`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `DependentEmployee`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  return (
    <div className=" mt-5">
      {/* second tabs */}

      {/* searchbar and button */}

      <div className="mt-6 flex justify-between">
        <div className="flex gap-x-4 items-center">
          <Search
            searchKey={[
              "employee_id",
              "visa_reference_number",
              "border_number",
              "iqama_number",
              "client_id",
              "emp_id",
              "sponsor_id",
            ]}
            setSearchWords={setSearchWords}
          />
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[35px]"
            onClick={() => downloadFile()}
          >
            DOWNLOAD
          </button>
        </div>
        <input
          type="date"
          className="rounded-md px-8  outline-none border-2 border-gray"
        />
        <div className="flex gap-x-2">
          <button
            className="bg-red text-white px-4 rounded-md py-2 text-sm h-[35px]"
            onClick={() => downloadEmployeeFile()}
          >
            DOWNLOAD LIST
          </button>
          <button className="bg-red text-white px-4 rounded-md py-2 text-sm h-[35px]">
            UPLOAD DETAILS
          </button>
        </div>
      </div>

      {/* table */}

      <div
        className={`grid grid-cols-table-financeDesk-dependentPayment auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md mt-10`}
      >
        {titles.map((t, index) => (
          <p key={index} className="font-semibold uppercase">
            {t}
          </p>
        ))}

        {currentList?.map((list, index) => (
          <React.Fragment key={index}>
            <PaginationIndex index={index} />
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list?.dependent_name || "-"}
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                // textToHighlight={list.dependent_dob || "-"}
                textToHighlight={
                  list.dependent_dob
                    ? new Date(list.dependent_dob)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"
                }
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list.dependent_iqama_number || "-"}
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list.relation || "-"}
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list.insurance_class || "-"}
              />
            </p>

            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list.gender || "-"}
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list.HEAD_OF_FAMILY || "-"}
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                // textToHighlight={list.apply_date || "-"}
                textToHighlight={
                  list.apply_date
                    ? new Date(list.apply_date)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"
                }
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list.amount_paid || "-"}
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list.invoiceNumber || "-"}
              />
            </p>

            <hr
              className={`border-[1.5px] border-slate-100  w-full col-span-full `}
            />
          </React.Fragment>
        ))}
      </div>

      <Pagination />
    </div>
  );
}
